import showPopup from '@/components/showPopup'
import LoginOrRegPopup from './loginOrRegPopup.vue'

export default function showLoginOrReg() {
  showPopup(LoginOrRegPopup, {position: 'bottom', round: true, style: {backgroundColor: 'var(--theme-primary-dark)'}})
}
